export default __webpack_public_path__ + "static/media/textbg03@2x.93b56af3.png";